module.exports = __webpack_public_path__ + "img/3.b3a2fcf2.png";